import React from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import getNameday from '../../static/namedays'
import moment from 'moment-timezone'

const SidebarNamedays = ({ timestamp }) => {
  const time = moment(timestamp)
  const names = getNameday(time.format('DDMM'))
  const today = time.format('D.M.')

  return (
    <section id='namedays' className='sidebox'>
      <h3 className='sidebox-header'><span>Nimipäivät</span><span>{ today }</span></h3>
      <div className='sidebox-content'>{ names }</div>
    </section>
  )
}

SidebarNamedays.propTypes = exact({
  timestamp: PropTypes.number.isRequired,
})

export default SidebarNamedays
